import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameLetter'
})
export class NameLetterPipe implements PipeTransform {

  transform(firstName?: any, lastName?: any, nickName?: any): any {
    let result = "";
    if ((!firstName && !lastName) && nickName) {
      result = nickName.substr(0, 1);
    } else {
      if (firstName) {
        result = result + firstName.substr(0, 1);
      }
      if (lastName) {
        result = result + lastName.slice(-1);
      }
    }
    return result.toUpperCase();
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/pipes/name-letter.pipe.ts